import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import { CartDrawer } from "@/components/CartDrawer";
import { BookRequestModal } from "@/components/BookRequestModal";
import { AmbientBackground } from "@/components/AmbientBackground";
import { trackVisit } from "@/api";
import Home from "@/pages/Home";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Legal from "@/pages/Legal";
import ProductPage from "@/pages/ProductPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import CustomerPanel from "@/pages/CustomerPanel";
import AdminLogin from "@/pages/admin/AdminLogin";
import Admin from "@/pages/admin/Admin";

function Layout() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  useEffect(() => { trackVisit(); }, []);

  useEffect(() => {
    if (!location.hash) window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <AmbientBackground />
      <div className="relative z-[1]">
        {!isAdmin && <Navbar />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/produkt/:id" element={<ProductPage />} />
          <Route path="/regulamin" element={<Legal page="regulamin" />} />
          <Route path="/polityka-prywatnosci" element={<Legal page="polityka-prywatnosci" />} />
          <Route path="/wysylka" element={<Legal page="wysylka" />} />
          <Route path="/platnosci" element={<Legal page="platnosci" />} />
          <Route path="/platnosc/sukces" element={<PaymentSuccess />} />
          <Route path="/platnosc/anulowana" element={<PaymentCancel />} />
          <Route path="/konto" element={<CustomerPanel />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        {!isAdmin && <Footer />}
      </div>
      {!isAdmin && <CartDrawer />}
      <BookRequestModal />
      <ChatWidget />
      <Toaster position="top-center" theme="dark" richColors />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-slate-950">
      <BrowserRouter>
        <CartProvider>
          <Layout />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
